pensionSavingsPlanService.$inject = ['$http', 'apiBase', '$q']

function pensionSavingsPlanService ($http, apiBase, $q) {
  var endpointPath = apiBase + 'v1/pension'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  function dps (data) {
    var canceler = $q.defer()

    var promise = $http({
      url: endpoint('dps/calc/savingsPlan'),
      method: 'POST',
      timeout: canceler.promise,
      data: data
    })
    return {
      promise: promise,
      canceler: canceler
    }
  }

  function pp (data) {
    var canceler = $q.defer()

    var promise = $http({
      url: endpoint('pp/calc/savingsPlan'),
      method: 'POST',
      timeout: canceler.promise,
      data: data
    })
    return {
      promise: promise,
      canceler: canceler
    }
  }

  return {
    dps: dps,
    pp: pp
  }
}

exports.pensionSavingsPlanService = pensionSavingsPlanService
